module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[49]414.4132aa2.woff2";